import React from "react";
import Icon from "root/libs/ui-components/src/lib/Icons/Icon";
import { IntlPropType } from "root/libs/core-libs/src";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { FeedbackMessage } from "root/libs/ui-components/src";
import { SS } from "root/libs/constants/src";
import { CATEGORIES } from "one-time-shipment/src/containers/SpotShipmentPage/constants";
import customPallet from "iconsTwoColors/cx/custom-pallet.svg";

import { PresetSelectorHeadline, PresetSelectorGroup } from "./styled";
import { FreightRadioCards } from "../styled";

const mapPackageCategoryToCopyIdPrefix = {
  pallet: "ShipmentLaneComponent.Pallet.Select",
  containers: "ShipmentLaneComponent.Containers.Select",
  parcels: "PresetSizeSelector.title",
  truckload: "ShipmentLaneComponent.Truckload.Select",
};

export const PackagePreserSelector = injectIntl(
  ({
    selectedCategory,
    onChange,
    onBlur,
    value,
    intl,
    spotShipmentPresetSizes,
    selectedUnitSystem,
    unitSystem,
    nameSuffix,
    validity,
    presetSegment,
  }) => {
    const segmentPresets = spotShipmentPresetSizes[presetSegment];
    const presets = selectedCategory
      ? segmentPresets.filter((preset) => preset.category === selectedCategory)
      : segmentPresets;

    const fieldName =
      nameSuffix !== undefined ? `preset-${nameSuffix}` : "preset";
    const feedbackId =
      nameSuffix !== undefined ? `preset-${nameSuffix}` : "preset";
    const handleChange = (e) => {
      const preset = presets.find(
        (presetItem) => presetItem.key === e.target.value
      );
      if (onChange) {
        onChange(preset ?? null);
      }
    };
    const isRequired = selectedCategory === CATEGORIES.Pallet;

    const customPresets =
      selectedCategory === CATEGORIES.Pallet
        ? [
            {
              label: intl.formatMessage({
                id: `PresetSizeSelector.Custom`,
              }),
              required: isRequired,
              value: "",
              icon: (
                <Icon
                  icon={customPallet}
                  iconSize="xlarge"
                  seAs="decorative"
                  width={{ mobile: "85px", desktop: "70px" }}
                  height={{ mobile: "50px" }}
                />
              ),
              description: intl.formatMessage({
                id: `PresetSizeSelector.ManualDimensions`,
              }),
            },
          ]
        : [];

    return (
      <PresetSelectorGroup>
        <PresetSelectorHeadline
          weight="800"
          priority={5}
          headlineDisplayType="p"
          className="no-padding"
        >
          {intl.formatMessage({
            id:
              mapPackageCategoryToCopyIdPrefix[selectedCategory] ??
              "PresetSizeSelector.title",
          })}
        </PresetSelectorHeadline>
        <FreightRadioCards
          availableColumns={4}
          itemsCount={presets.length + 1}
          name={fieldName}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          className="side-by-side"
          ariaInvalid={validity && validity.hasError}
          options={[
            ...presets.map((preset) => ({
              label: intl.formatMessage({
                id: `PresetSizeSelector.${preset.labelFreight ?? preset.label}`,
              }),
              required: isRequired,
              value: preset.key,
              icon: (
                <Icon
                  data-testid={preset.key}
                  icon={preset.svg}
                  iconSize="xlarge"
                  seAs="decorative"
                  width={{
                    mobile: "85px",
                    desktop: "70px",
                  }}
                  height={{
                    mobile: "50px",
                  }}
                />
              ),
              description: intl.formatMessage(
                {
                  id: !preset[selectedUnitSystem]?.height
                    ? `PresetSizeCardGroup.dimensionsLabelWithoutHeight`
                    : `PresetSizeCardGroup.dimensionsLabel`,
                },
                {
                  presetLabel: preset.label,
                  valuesLength: preset[selectedUnitSystem]?.length,
                  valuesWidth: preset[selectedUnitSystem]?.width,
                  valuesHeight: preset[selectedUnitSystem]?.height,
                  unitLabel: unitSystem[selectedUnitSystem].length,
                }
              ),
            })),
            ...customPresets,
          ]}
        />
        {validity && validity.hasError && validity.feedbackMessageId && (
          <FeedbackMessage
            id={`${feedbackId}-validation-feedback`}
            copyNamespace={SS}
            feedback={validity}
            feedbackMessageIdPrefix="preset"
            dataTestid={`${feedbackId}-validation-feedback`}
          />
        )}
      </PresetSelectorGroup>
    );
  }
);

PackagePreserSelector.propTypes = {
  selectedCategory: PropTypes.string,
  selectedUnitSystem: PropTypes.string,
  spotShipmentPresetSizes: PropTypes.object,
  unitSystem: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  intl: IntlPropType.isRequired,
  nameSuffix: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validity: PropTypes.object,
  presetSegment: PropTypes.string,
};
